(function () {
  function readPayload(button) {
    var el = button && button.jquery ? button[0] : button;
    if (!el || !el.getAttribute) return null;

    var variantId = el.getAttribute('data-variant');
    var productId = el.getAttribute('data-product-id');
    if (!variantId || !productId) return null;

    var price = parseFloat(el.getAttribute('data-product-price'));
    var currencyCode =
      (window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    return {
      productVariant: {
        id: String(variantId),
        title: el.getAttribute('data-product-variant-title') || 'Default Title',
        price: {
          amount: Number.isFinite(price) ? price : 0,
          currencyCode: currencyCode,
        },
        product: {
          id: String(productId),
          title: el.getAttribute('data-product-title') || '',
          vendor: el.getAttribute('data-product-vendor') || '',
          url: '/products/' + (el.getAttribute('data-product-handle') || ''),
          type: el.getAttribute('data-product-type') || '',
        },
      },
    };
  }

  function pushViewItemToDataLayer(payload) {
    if (!payload || !window.dataLayer) return;

    var variant = payload.productVariant;
    var product = variant.product;

    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: variant.price.currencyCode,
        value: variant.price.amount,
        items: [
          {
            item_id: variant.id,
            item_name: product.title,
            item_brand: product.vendor,
            item_category: product.type,
            price: variant.price.amount,
            quantity: 1,
          },
        ],
      },
    });
  }

  function trackMetaViewContent(payload) {
    if (!payload || typeof window.fbq !== 'function') return;

    var variant = payload.productVariant;
    var product = variant.product;

    window.fbq('track', 'ViewContent', {
      content_ids: [variant.id],
      content_type: 'product',
      content_name: product.title,
      value: variant.price.amount,
      currency: variant.price.currencyCode,
    });
  }

  function readCampaignContextFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return {
        SongID: params.get('SongID') || '',
        ArtistID: params.get('ArtistID') || '',
        AlbumID: params.get('AlbumID') || '',
      };
    } catch (e) {
      return { SongID: '', ArtistID: '', AlbumID: '' };
    }
  }

  function trackTripleWhaleProductView(payload) {
    if (!payload || typeof window.TriplePixel !== 'function') return;

    var variant = payload.productVariant;
    var product = variant.product;
    var variantId = variant.id;
    var productContext = {
      id: String(product.id),
      name: product.title,
      price: String(variant.price.amount),
      variant: String(variantId),
      av: {},
    };
    productContext.av[variantId] = true;

    if (window.TriplePixelData) {
      window.TriplePixelData.product = productContext;
    }

    window.TriplePixel('pageLoad', { product: productContext });
  }

  function trackKlaviyoViewedProduct(button, payload) {
    if (!payload || !window.klaviyo) return;

    var el = button && button.jquery ? button[0] : button;
    var variant = payload.productVariant;
    var product = variant.product;
    var campaign = readCampaignContextFromUrl();
    var productUrl = window.location.origin + product.url;
    var imageUrl = (el && el.getAttribute('data-product-image')) || '';

    var item = {
      Name: product.title,
      ProductID: product.id,
      SKU: variant.id,
      Brand: product.vendor,
      Price: variant.price.amount,
      URL: productUrl,
      ImageURL: imageUrl,
      SongID: campaign.SongID,
      ArtistID: campaign.ArtistID,
      AlbumID: campaign.AlbumID,
    };

    if (typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Viewed Product', item);
    } else if (typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', 'Viewed Product', item]);
    }

    if (typeof window.klaviyo.trackViewedItem === 'function') {
      window.klaviyo.trackViewedItem({
        Title: product.title,
        ItemId: product.id,
        ImageUrl: imageUrl,
        Url: productUrl,
        Metadata: {
          Brand: product.vendor,
          Price: variant.price.amount,
          SKU: variant.id,
          SongID: campaign.SongID,
          ArtistID: campaign.ArtistID,
          AlbumID: campaign.AlbumID,
        },
      });
    }
  }

  function publishCampaignProductViewed(button) {
    var payload = readPayload(button);
    if (!payload) return;

    // Standard events (e.g. product_viewed) cannot be published from the theme.
    // Use a custom customer event and forward to Meta/GTM from the storefront.
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('gpm:campaign_product_viewed', payload);
    }

    window.dataLayer = window.dataLayer || [];
    pushViewItemToDataLayer(payload);
    trackMetaViewContent(payload);
    trackKlaviyoViewedProduct(button, payload);
    trackTripleWhaleProductView(payload);
  }

  window.gpmPublishCampaignProductViewed = publishCampaignProductViewed;
})();
